export default __webpack_public_path__ + "static/media/Product-Id.6beedcb1.jpg";